import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import { NavLink } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
  secondaryNavLink: {
    color: props => `rgb(${props.configColors['--color_55']})`,
    margin:'15px 5px',
    padding: '8px 20px',
    lineHeight: '22px',
    verticalAlign: 'middle',
    borderRadius:3,
    '&:hover': {
      backgroundColor: props => `rgb(${props.configColors['--color_1']})`,
      color: props => `rgb(${props.configColors['--color_54']})`,
    }
  },
  secondaryNavLinkActive:{
    backgroundColor: props => `rgb(${props.configColors['--color_1']})`,
    color: props => `rgb(${props.configColors['--color_54']})`,
  },
  navIcon:{
    display: 'inline-block',
    marginBottom: -7,
    marginRight: theme.spacing(1)
  }
}));

export default function StyledSecondaryNavLink(props) {
  const classes = useStyles(props);

  return (
    <NavLink to={props.to} activeClassName={classes.secondaryNavLinkActive} className={classes.secondaryNavLink}>
        {props.name}
    </NavLink>
  );
}
